var rtl_rtlignore_default = {
  "rtl": "RJzUs",
  "ltr": "Sai3T"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
